export const ABORT_RATE_7_DAY_AVERAGE_PRIZE_ENABLEMENT_GOAL = 8.0;

export const GAMES_PER_DAU_7_DAY_AVERAGE_PRIZE_ENABLEMENT_GOAL = 6;
export const SKILLZ_DAU_7_DAY_AVERAGE_PRIZE_ENABLEMENT_GOAL = 75;
export const DAY_7_RETENTION_7_DAY_AVERAGE_PRIZE_ENABLEMENT_GOAL = 4.5;
export const INSTALLS_TO_2Z_7_DAY_AVERAGE_PRIZE_ENABLEMENT_GOAL = 70;

export const SKILLZ_DAU_7_DAY_AVERAGE_SYNC_PRIZE_ENABLEMENT_GOAL = 75;
